module.exports = __webpack_public_path__ + "static/img/nav4.ba83024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav4.jpg
// module id = yv+b
// module chunks = 31